document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.section-header');

  document.querySelectorAll('[data-8th-nav]').forEach((navSection) => {
    const sectionWrapper = navSection.closest('.shopify-section') || navSection.parentElement;
    const ceiling = sectionWrapper?.querySelector('[data-nav-ceiling]');
    const anchorLinks = sectionWrapper?.querySelectorAll('[data-nav-target]') || [];
    const ceilingItems = ceiling ? ceiling.querySelectorAll('[data-target]') : [];

    if (!ceiling || !ceilingItems.length) return;

    let ticking = false;

    const getHeaderBottom = () => {
      if (!header) return 0;
      return Math.max(0, header.getBoundingClientRect().bottom);
    };

    const getCeilingHeight = () => {
      if (ceiling.hidden) return 0;
      return ceiling.offsetHeight;
    };

    const getScrollOffset = () => getHeaderBottom() + getCeilingHeight();

    const setActiveItem = (targetId) => {
      ceilingItems.forEach((item) => {
        const isActive = item.getAttribute('data-target') === targetId;
        item.classList.toggle('active', isActive);
      });
    };

    const scrollToTarget = (targetId) => {
      const targetElement = document.getElementById(targetId);
      if (!targetElement) return;

      history.replaceState(null, '', `#${targetId}`);

      const offset = getScrollOffset();
      const top = targetElement.getBoundingClientRect().top + window.scrollY - offset;

      window.scrollTo({
        top: Math.max(0, top),
        behavior: 'smooth',
      });
    };

    const updateCeilingVisibility = () => {
      const headerBottom = getHeaderBottom();
      const navBottom = navSection.getBoundingClientRect().bottom + window.scrollY;
      const shouldShow = window.scrollY + headerBottom >= navBottom - 1;

      ceiling.hidden = !shouldShow;
      ceiling.classList.toggle('is-visible', shouldShow);

      if (shouldShow) {
        ceiling.style.top = `${headerBottom}px`;
      } else {
        ceiling.style.removeProperty('top');
      }
    };

    const updateActiveByScroll = () => {
      const offset = getScrollOffset() + 8;
      const scrollPosition = window.scrollY + offset;
      let matchedId = null;

      ceilingItems.forEach((item) => {
        const targetId = item.getAttribute('data-target');
        if (!targetId) return;

        const targetElement = document.getElementById(targetId);
        if (!targetElement) return;

        const moduleTop = targetElement.offsetTop;
        const moduleBottom = moduleTop + targetElement.offsetHeight;

        if (scrollPosition >= moduleTop && scrollPosition < moduleBottom) {
          matchedId = targetId;
        }
      });

      if (matchedId) {
        setActiveItem(matchedId);

        const activeItem = ceiling.querySelector(`[data-target="${matchedId}"]`);
        const list = ceiling.querySelector('ul');

        if (activeItem && list) {
          const leadOffset = 100;
          const targetScroll = activeItem.offsetLeft - leadOffset;
          const maxScroll = Math.max(0, list.scrollWidth - list.clientWidth);
          list.scrollLeft = Math.max(0, Math.min(targetScroll, maxScroll));
        }
      }
    };

    const onScroll = () => {
      if (ticking) return;

      ticking = true;
      requestAnimationFrame(() => {
        updateCeilingVisibility();
        updateActiveByScroll();
        ticking = false;
      });
    };

    const handleAnchorClick = (event, targetId) => {
      if (!targetId) return;

      event.preventDefault();
      setActiveItem(targetId);
      scrollToTarget(targetId);
    };

    anchorLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        handleAnchorClick(event, link.getAttribute('data-nav-target'));
      });
    });

    updateCeilingVisibility();
    updateActiveByScroll();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', () => {
      updateCeilingVisibility();
      updateActiveByScroll();
    });

    if (header) {
      const headerObserver = new MutationObserver(() => {
        updateCeilingVisibility();
        updateActiveByScroll();
      });

      headerObserver.observe(header, {
        attributes: true,
        attributeFilter: ['class'],
      });

      header.addEventListener('transitionend', () => {
        updateCeilingVisibility();
        updateActiveByScroll();
      });
    }

    const initialHash = window.location.hash.replace('#', '');

    if (initialHash) {
      const hashItem = Array.from(ceilingItems).find(
        (item) => item.getAttribute('data-target') === initialHash
      );

      if (hashItem) {
        setActiveItem(initialHash);
        requestAnimationFrame(() => scrollToTarget(initialHash));
      }
    }
  });
});
